import { createRangeTagManager } from '../../utils/createRangeTagManager';

export const houseYearTagManager = createRangeTagManager({
  jsonQueryKey: 'house_year',
  template: 'Год постройки %s',
  id: 'houseYear',
});
